import React, { useEffect, useState } from 'react'
import './my-levels-list.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import RewardsCard from '../rewards-card/rewards-card.component';
import PlayerNameIcon from '../player-name-icon.component';
import mysteryImg from '@/assets/mystery-badge.png';
import { getGameActivityFromDb } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';
import TransactionView from '@/components/SHARED/tranaction-view/transaction-view.component';

const MyLevelsList = ({
  gameData,
  playerData,
  gameElements
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [loading, setLoading] = useState(true);
  const [sortedList, setSortedList] = useState([]);
  const [activityRecords, setActivityRecords] = useState(null);
  const [currentLevel, setCurrentLevel] = useState(null);
  const [ indActivityData, setIndActivityData ] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!gameData || !playerData || !gameElements) return;
    console.log(gameElements);
    const sorted = Object.values(gameElements).filter(e => e.type === 'level')
      .sort((a, b) => a.opt_pointMinimum > b.opt_pointMinimum ? 1 : -1)
    setSortedList(sorted);
    for (let i of sorted) {
      if (i.opt_pointMinimum > playerData?.points) {
        break;
      } else {
        setCurrentLevel(i.id);
      }
    }
    setLoading(false);
  }, [gameData, playerData, gameElements])

  useEffect(() => {
    if (!currentLevel || !sortedList) return;
    // getLevelActivityRecords();
    setTimeout(() => {
      const el = document.getElementById(`level-${currentLevel}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }
    }, 500)
  }, [currentLevel, sortedList])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!sortedList) {
        setLoading(false);
      }
    }, 3000)

    return () => {
      if (timer) clearTimeout(timer);
    }
  }, [])

  function getLevelActivityRecords(more) {
    let levelArr = [];
    if (more) {

    } else {
      const levelIds = sortedList.map(l => l.id);
      const index = levelIds.indexOf(currentLevel);
      if (index >= 0) {
        const startIndex = Math.max(0, index - 10);
        levelArr = levelIds.slice(startIndex, index + 1);
      }
    }
    getGameActivityFromDb({
      'gameId': gameData.gameId,
      'queryArr': [
        {
          'key': 'elementId',
          'condition': 'in',
          'value': levelArr
        }
      ],
      'once': true,
      'callback': callback
    })

    function callback(data) {
      console.log(data);
      setActivityRecords(data);
      setLoading(false);
    }
  }

  // useEffect(() => {
  //     if (!playerData || !gameElements) return;
  //     // console.log(playerActivity);
  //     const levels = Object.values(gameElements).filter(e => e.type === 'level')
  //     let newLevels = [];
  //     levels.sort((a,b) => a.opt_pointMinimum < b.opt_pointMinimum ? 1 : -1)
  //     .map(l => {
  //         // console.log(l);
  //         let newLevel = {...l}
  //         if (
  //             playerActivity && 
  //             playerData.levels && 
  //             playerData.levels[newLevel.id]
  //         ) {
  //             const levelActivity = Object.values(playerActivity)
  //             .filter(a => 
  //                 a.type === 'levels' && 
  //                 (
  //                     (
  //                         a.spec &&
  //                         a.spec.includes(newLevel.id)
  //                     ) ||
  //                     a.elementId === newLevel.id
  //                 )
  //             )[0]
  //             if (!levelActivity) {
  //                 newLevels.push(newLevel);
  //                 return;
  //             }
  //             // console.log(levelActivity);
  //             newLevel.earned = levelActivity.ts
  //             if (levelActivity.data) {
  //                 newLevel.data = levelActivity.data;
  //             }
  //         }
  //         newLevels.push(newLevel);
  //     })
  //     setSortedList(newLevels);
  //     setLoading(false);
  // }, [playerData, gameElements, playerActivity])

  return (
    <div className={`level-earnings-list ${screenSize}`}>
      <div className='g-card list-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div>
          <div className='card-title split'>
            Game Levels
            {
              (location.pathname.includes('/manage/')) &&
              <PlayerNameIcon player={playerData} />
            }
          </div>
          <hr />
        </div>
        <Routes>
          <Route path='' element={
            <div className='levels-list'>
              {
                (loading)
                  ?
                  <div className='center-col'><ThreeDotsLoader /></div>
                  :
                  (sortedList)
                    ?
                    sortedList
                      .sort((a, b) => a.opt_pointMinimum < b.opt_pointMinimum ? 1 : -1)
                      .map(l => {
                        // console.log(l);
                        const earned = playerData?.levels?.[l.id]?.count > 0;
                        const earnedDate = earned ? format(playerData.levels[l.id].ts, "P") : null;
                        console.log(earned);
                        return (
                          <div
                            key={l.id}
                            id={`level-${l.id}`}
                            className={`g-list-item level-item ${currentLevel === l.id
                                ? 'current'
                                : ''
                              }`}>
                            <ImageContainer
                              src={earned ? l.icon : '/images/icons/mystery-badge.png'}
                              className={`icon ${!earned && !l.opt_preview
                                ? 'opaque'
                                : ''
                                }`}
                              grayscale={!earned} />
                            <div className='info'>
                              <div className={`title ${!l.opt_preview && !earned ? 'opaque' : ''}`}>{earned || l.opt_preview ? l.name : 'Mystery Level'}</div>
                              {/* {
                                            (l.earned) &&
                                            <div className='meta'>
                                                Earned: {format(new Date(l.earned), "Pp")}
                                            </div>
                                        } */}
                              <div className={`meta ${!l.opt_preview && !earned ? 'opaque' : ''}`}>
                                Min: {l.opt_preview || earned ? l.opt_pointMinimum : '???'}
                              </div>
                            </div>
                            {
                              (
                                earned &&
                                screenSize !== 'mobile' &&
                                screenSize !== 'tablet'
                              ) &&
                              <div className='meta'>
                                Earned: {earnedDate}
                              </div>
                            }
                            <div className='buttons'>
                              {
                                (earned) &&
                                <button
                                  className='g-button small-btn'
                                  onClick={() => navigate(l.path)} >
                                  View
                                </button>
                              }
                            </div>
                            {/* <div 
                                        className='desc' 
                                        dangerouslySetInnerHTML={{__html: l.desc}}>
                                    </div> */}
                            {/*
                                        (l.data && Object.values(l.data).length > 0) &&
                                        <div className='rewards'>
                                            <b>My Rewards</b>
                                            <div className='g-space-0-5'></div>
                                            {
                                                Object.values(l.data).map((r, index) => (
                                                    <div 
                                                        key={r.ts + '_' + index}
                                                        className='reward-card' >
                                                        <RewardsCard reward={r} />
                                                    </div>
                                                )) 
                                            }
                                        </div>
                                    */}
                          </div>
                        )
                      })
                    :
                    <h4 className='center-col'>
                      No earnings yet...
                    </h4>
              }
            </div>
          }></Route>
          {/* <Route path=':transPath/*' element={
            (gameData && indActivityData)
              ?
              <div className='g-card'>
                <TransactionView
                  playerData={playerData}
                  gameElements={gameElements}
                  playerList={{ [playerData.playerId]: playerData }}
                  hidePlayer={true}
                  activityToDisplay={[indActivityData]}
                />
              </div>
              :
              <div></div>
          }></Route> */}

        </Routes>
      </div>
    </div>
  )
}

export default MyLevelsList